import { render, staticRenderFns } from "./FileRenderer.vue?vue&type=template&id=273acd4e&scoped=true"
import script from "./FileRenderer.vue?vue&type=script&lang=js"
export * from "./FileRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273acd4e",
  null
  
)

export default component.exports